export default __webpack_public_path__ + "static/media/campus (2).aaf8bde0.jpg";